// @flow
import React, { Component } from "react";
import MaskedInput from "react-text-mask";

import { CityOptions } from "../../../../Constants/GlobalVariables/CityOptions";
import { phoneNumberMask } from "../../../../Constants/GlobalVariables/InputMasks";
import emailMask from "text-mask-addons/dist/emailMask";
import { determineCityAndDistrictOptionsFromProps } from "../../../../Utilities/Helpers/OptionsHelpers";

type PropsType = {
  formElements: Object,
  controlElements: Object,
  request_id: string,
  related_secret: string,
  translate: string => void,
  userRegisterFormElementValueChange: (string, string) => void,
  userRegisterControlElementValueChange: (string, string) => void,
  userRegisterFormSubmit: (Object, string, string) => void
};

type StateType = {
  selectedCity: string,
  districtOptions: Array<Object>
};

class UserRegisterForm extends Component<PropsType, StateType> {
  constructor(props: Object) {
    super(props);

    this.state = determineCityAndDistrictOptionsFromProps(props);
  }

  componentWillReceiveProps(nextProps: Object) {
    this.setState(determineCityAndDistrictOptionsFromProps(nextProps));
  }

  render() {
    const {
      formElements,
      controlElements,
      request_id,
      related_secret,
      translate,
      userRegisterFormElementValueChange,
      userRegisterControlElementValueChange,
      userRegisterFormSubmit
    } = this.props;
    const { districtOptions } = this.state;
    return (
      <div>
        <p className="mb-3 text-center">{translate("UserRegisterLocale.form.header")}</p>
        <hr className="w-30" />
        <div className="form-row text-center">
          <div className="form-group col-md-8 offset-2">
            <input
              className="form-control form-control-sm"
              type="text"
              placeholder={translate("UserRegisterLocale.form.form_unit.first_name")}
              value={formElements.first_name}
              name="first_name"
              onChange={event => {
                userRegisterFormElementValueChange(event.target.name, event.target.value);
              }}
            />
          </div>
          <div className="form-group col-md-8 offset-2">
            <input
              className="form-control form-control-sm"
              type="text"
              placeholder={translate("UserRegisterLocale.form.form_unit.last_name")}
              value={formElements.last_name}
              name="last_name"
              onChange={event => {
                userRegisterFormElementValueChange(event.target.name, event.target.value);
              }}
            />
          </div>
          <div className="form-group col-md-8 offset-2">
            <MaskedInput
              className="form-control form-control-sm"
              type="text"
              placeholder={translate("UserRegisterLocale.form.form_unit.phone")}
              value={formElements.phone}
              mask={phoneNumberMask}
              name="phone"
              onChange={event => {
                userRegisterFormElementValueChange(event.target.name, event.target.value);
              }}
            />
          </div>
          <div className="form-group col-md-8 offset-2">
            <textarea
              className="form-control form-control-sm"
              rows="2"
              type="text"
              placeholder={translate("UserRegisterLocale.form.form_unit.address")}
              value={formElements.address}
              name="address"
              onChange={event => {
                userRegisterFormElementValueChange(event.target.name, event.target.value);
              }}
            />
          </div>
          <div className="form-group col-md-4 offset-2">
            <select
              className="form-control form-control-sm"
              placeholder={translate("UserRegisterLocale.form.form_unit.city")}
              value={formElements.city}
              name="city"
              onChange={event => {
                userRegisterFormElementValueChange(event.target.name, event.target.value);
              }}
            >
              <option value="" disabled>
                {translate("UserRegisterLocale.form.form_unit.city")}
              </option>
              <option value="">---</option>
              {CityOptions.map((city, index) => <option key={index}>{city.text}</option>)}
            </select>
          </div>
          <div className="form-group col-md-4">
            {districtOptions.length === 0 ? (
              <select
                className="form-control form-control-sm"
                placeholder={translate("UserRegisterLocale.form.form_unit.district")}
                value={formElements.district}
                name="district"
              >
                <option value="" disabled>
                  {translate("UserRegisterLocale.form.form_unit.district_no_results")}
                </option>
              </select>
            ) : (
              <select
                className="form-control form-control-sm"
                placeholder={translate("UserRegisterLocale.form.form_unit.district")}
                value={formElements.district}
                name="district"
                onChange={event => {
                  userRegisterFormElementValueChange(event.target.name, event.target.value);
                }}
              >
                <option value="" disabled>
                  {this.props.translate("UserRegisterLocale.form.form_unit.district")}
                </option>
                <option value="">---</option>
                {districtOptions.map((district, index) => <option key={index}>{district.text}</option>)}
                )}
              </select>
            )}
          </div>
          <div className="form-group col-md-4 offset-2">
            <input
              className="form-control form-control-sm"
              type="text"
              placeholder={translate("UserRegisterLocale.form.form_unit.postal_code")}
              value={formElements.postal_code}
              name="postal_code"
              onChange={event => {
                userRegisterFormElementValueChange(event.target.name, event.target.value);
              }}
            />
          </div>
          <div className="form-group col-md-4">
            <input
              className="form-control form-control-sm"
              type="text"
              placeholder={translate("UserRegisterLocale.form.form_unit.country")}
              value={formElements.country}
              name="country"
              onChange={event => {
                userRegisterFormElementValueChange(event.target.name, event.target.value);
              }}
            />
          </div>
          <hr className="w-30" />
          <div className="form-group col-md-8 offset-2">
            <MaskedInput
              className="form-control form-control-sm"
              type="text"
              placeholder={translate("UserRegisterLocale.form.form_unit.email")}
              value={formElements.email}
              mask={emailMask}
              name="email"
              onChange={event => {
                userRegisterFormElementValueChange(event.target.name, event.target.value);
              }}
            />
          </div>
          <div className="form-group col-md-8 offset-2">
            <input
              className="form-control form-control-sm"
              type="password"
              placeholder={translate("UserRegisterLocale.form.form_unit.password")}
              value={formElements.password}
              name="password"
              onChange={event => {
                userRegisterFormElementValueChange(event.target.name, event.target.value);
              }}
            />
          </div>
          <div className="form-group col-md-8 offset-2">
            <div
              className={`input-group ${
                formElements.password !== "" && formElements.password === controlElements.password_verify
                  ? "is-valid"
                  : "is-invalid"
              }`}
            >
              <div className="input-group-prepend">
                <span className="input-group-text">
                  {formElements.password !== "" && formElements.password === controlElements.password_verify ? (
                    <i className="fas fa-check text-success" />
                  ) : (
                    <i className="fas fa-times text-danger" />
                  )}
                </span>
              </div>
              <input
                className={`form-control form-control-sm ${
                  formElements.password !== "" && formElements.password === controlElements.password_verify
                    ? "is-valid"
                    : "is-invalid"
                }`}
                type="password"
                placeholder={translate("UserRegisterLocale.form.form_unit.password_verify")}
                value={controlElements.password_verify}
                name="password_verify"
                onChange={event => {
                  userRegisterControlElementValueChange(event.target.name, event.target.value);
                }}
              />
            </div>
          </div>
          <div className="form-group col-md-8 offset-2">
            <button
              className="btn btn-block btn-primary"
              onClick={() => {
                userRegisterFormSubmit(formElements, request_id, related_secret);
              }}
            >
              {translate("CompanyRegisterLocale.form.form_unit.submit")}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default UserRegisterForm;



// WEBPACK FOOTER //
// ./src/Components/PublicAccountPages/Components/UserRegister/UserRegisterForm.js